import { jsx } from 'react/jsx-runtime';
/** Generates option nodes for native Select input */

var selectOptionsToOptionNodes = function selectOptionsToOptionNodes(opts) {
  return opts.map(function (option) {
    return jsx("option", Object.assign({
      value: option.value
    }, {
      children: option.label
    }), option.value);
  });
};

export { selectOptionsToOptionNodes };